<template>
  <div>
    <div v-if="searching">
      <search-screen
        :type="tp"
        @screen-click="toggleMode"
        @change="changeType"
      />

      <rg-toolbar-search :focused="true" @back="toggleMode" @search="search" />
    </div>

    <div v-else class="ui top fixed menu borderless">
      <button
        class="item icon"
        :class="$style.itemBtn"
        data-wd="sideToggler"
        @click="$store.dispatch('toggle')"
      >
        <i
          v-new-feature="user ? { id: 'notelists', target: null } : {}"
          class="content icon"
        />
      </button>

      <div :class="$style.titleCont">
        <h2 :class="$style.title">
          {{ resultTitle }}
        </h2>
      </div>

      <div v-show="$route.name !== 'home'" class="right menu">
        <button
          class="item icon"
          :class="$style.itemBtn"
          data-wd="inSearchToggler"
          @click="toggleMode"
        >
          <i class="search icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import toolbarMixins from '@/mixins/toolbar'
import RgToolbarSearch from '@/components/ToolbarSearch.vue'
import SearchScreen from '@/components/SearchScreen.vue'
import { mapState } from 'vuex'

export default {
  name: 'RgToolbar',
  components: {
    RgToolbarSearch,
    SearchScreen
  },
  mixins: [toolbarMixins],
  data () {
    return {
      searching: false,
      tp: 'book'
    }
  },
  methods: {
    toggleMode () {
      this.searching = !this.searching
    },
    changeType (type) {
      this.tp = type
    },
    search (text) {
      if (text !== '') {
        this.$router.push({
          name: 'searched',
          query: { q: text, tp: this.tp }
        })
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user
    })
  }
}
</script>

<style module>
@value rotating from '~@/stylesheets/app.css';
@value titleCont, title, transBtn from '~@/stylesheets/toolbar.css';

.itemBtn {
  composes: transBtn;

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
}
</style>
